"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ENDPOINTS_1 = __importDefault(require("../../../constants/app/ENDPOINTS"));
const http_service_1 = __importDefault(require("../../../services/http.service"));
const getSessionToken_1 = __importDefault(require("../../../utils/login/getSessionToken"));
const getPaymentToken_1 = __importDefault(require("../../../utils/payment/getPaymentToken"));
/**
 * Client interface to make GET Driver API call
 * @returns {Promise}
 */
const getCustomerDriver = () => {
    const requestId = 'GET_CUSTOMER_DRIVER';
    // JWT token is mandatory (Authenticated API)
    // session token can be passed in header for logged in user
    // for non logged in user pass temporary ptoken (this is used while fetching uploaded docs for driver)
    const token = (0, getSessionToken_1.default)() || (0, getPaymentToken_1.default)();
    // if token present then add to header
    // or else let api throw 401 error
    const config = {};
    if (token) {
        config.headers = {
            Authorization: `Bearer ${token}`,
        };
    }
    const endPoint = ENDPOINTS_1.default.CUSTOMER_SERVICE.DRIVER;
    return http_service_1.default.get(requestId, endPoint, config).then((response) => {
        return response.data;
    });
};
exports.default = getCustomerDriver;
